import angular from 'angular';
import {env, FEATURES} from 'acng/core/service/env';
import './layout';
import './achievement';
import './kiss';
import './privacyPolicy';
import './alternativeProducts';
import './comment';
import './games';
import './locale';
import './regard';
import './sexicon';
import './special';
import './pin';
import './friend';
import './hotornot/index.js';
import './fmotd/index.js';
import './voyager/index.js';
import {runRouter} from './core/service/router.js';
import {runBootstrap} from './core/service/templates.js';
import {atRouteDirective} from './core/directive/at-route';

/**
 * @typedef RootScopeTrait
 * @property {(name: string) => boolean} hasFeature -
 * @property {() => string} locale -
 * @property {typeof import("./core/service/location").main.globals} request
 * @property {import('./amateurPool/model/amateur').Amateur | null} dialogAmateur
 * @property {string[]} friends
 * @property {string[]} matches
 * @property {string[]} pins
 * @property {import('./messenger/model/dialog').Dialog[] & {changed?: number, online?: () => boolean}} dialogs
 */
/**
 * @typedef {angular.IRootScopeService & RootScopeTrait} RootScope
 */
angular
  .module('acngApp', [
    'core',
    'acngMisc',
    'ngSanitize',
    'pascalprecht.translate',
    'ngAnimate',
    'ons-actionslider',
    ...FEATURES.filter((v) => !['special', 'achievement', 'friend', 'pin', 'hotornot', 'imprint', 'terms', 'privacyPolicy'].includes(v)),
  ])
  .directive('atRoute', atRouteDirective)
  .run(['$rootScope', runRouter])
  .run(['$rootScope', '$compile', runBootstrap]);

for (const k in env) {
  angular.module('core').constant(k, env[k]);
}
